<template>
  <mdb-navbar
    expand="medium"
    hamburger
    color="aqua-gradient"
  >
    <mdb-navbar-brand tag="a" href="https://bridge8.tech/">
      <img src="/static/bridge8-logo.svg" height="30" alt="">
    </mdb-navbar-brand>
    <mdb-navbar-toggler>
      <mdb-navbar-nav>
        <mdb-nav-item to="/calc">Calculator</mdb-nav-item>
        <mdb-nav-item v-if="isUser" to="/orders">Orders</mdb-nav-item>
        <mdb-nav-item v-if="isUser" to="/calendar">Calendar</mdb-nav-item>
        <mdb-nav-item v-if="isManager" to="/admin">Admin</mdb-nav-item>
        <mdb-nav-item v-if="isManager" to="/import">Import</mdb-nav-item>
      </mdb-navbar-nav>
      <complaints/>
      <header-dropdown-profile v-if="authPassed" />
      <header-dropdown-login v-else />
    </mdb-navbar-toggler>
  </mdb-navbar>
</template>

<script>
import {
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavbarToggler,
  mdbNavItem,
  mdbNavbarNav
} from 'mdbvue'
import HeaderDropdownLogin from './HeaderDropdownLogin'
import HeaderDropdownProfile from './HeaderDropdownProfile'
import Complaints from './Complaints'
import { mapGetters, mapActions } from 'vuex'
import { errorCatch } from '../utils'

export default {
  name: 'Header',
  computed: {
    ...mapGetters('user', ['isAuthenticated', 'isUser', 'isAdmin', 'isManager']),
    authPassed () {
      return this.isAuthenticated
    }
  },
  methods: {
    ...mapActions('user', ['fetchProfile'])
  },
  created () {
    if (this.isAuthenticated) {
      this.fetchProfile()
        .then(() => this.$bus.$emit('profile-fetch-completed'))
        .catch(errorCatch('Fetch User Profile', this))
    }
  },
  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavItem,
    mdbNavbarNav,
    HeaderDropdownLogin,
    HeaderDropdownProfile,
    Complaints
  }
}
</script>

<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Header.vue